import React from 'react';
import { IconProps } from '../types';
const MinecraftLeatherHelmetOverlay: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="7" y="3" width="1" height="1" fill="rgba(52, 33, 21, 255)" />
<rect x="8" y="3" width="1" height="1" fill="rgba(52, 33, 21, 255)" />
<rect x="6" y="4" width="1" height="1" fill="rgba(52, 33, 21, 255)" />
<rect x="7" y="4" width="1" height="1" fill="rgba(149, 94, 59, 255)" />
<rect x="8" y="4" width="1" height="1" fill="rgba(149, 94, 59, 255)" />
<rect x="9" y="4" width="1" height="1" fill="rgba(52, 33, 21, 255)" />
<rect x="6" y="5" width="1" height="1" fill="rgba(52, 33, 21, 255)" />
<rect x="7" y="5" width="1" height="1" fill="rgba(149, 94, 59, 255)" />
<rect x="8" y="5" width="1" height="1" fill="rgba(114, 72, 46, 255)" />
<rect x="9" y="5" width="1" height="1" fill="rgba(52, 33, 21, 255)" />
<rect x="6" y="6" width="1" height="1" fill="rgba(52, 33, 21, 255)" />
<rect x="7" y="6" width="1" height="1" fill="rgba(114, 72, 46, 255)" />
<rect x="8" y="6" width="1" height="1" fill="rgba(85, 53, 33, 255)" />
<rect x="9" y="6" width="1" height="1" fill="rgba(52, 33, 21, 255)" />
<rect x="7" y="7" width="1" height="1" fill="rgba(52, 33, 21, 255)" />
<rect x="8" y="7" width="1" height="1" fill="rgba(52, 33, 21, 255)" />
<rect x="6" y="8" width="1" height="1" fill="rgba(7, 4, 3, 255)" />
<rect x="7" y="8" width="1" height="1" fill="rgba(7, 4, 3, 255)" />
<rect x="8" y="8" width="1" height="1" fill="rgba(7, 4, 3, 255)" />
<rect x="9" y="8" width="1" height="1" fill="rgba(7, 4, 3, 255)" />
<rect x="6" y="9" width="1" height="1" fill="rgba(7, 4, 3, 255)" />
<rect x="7" y="9" width="1" height="1" fill="rgba(7, 4, 3, 255)" />
<rect x="8" y="9" width="1" height="1" fill="rgba(7, 4, 3, 255)" />
<rect x="9" y="9" width="1" height="1" fill="rgba(7, 4, 3, 255)" />
<rect x="6" y="10" width="1" height="1" fill="rgba(7, 4, 3, 255)" />
<rect x="7" y="10" width="1" height="1" fill="rgba(7, 4, 3, 255)" />
<rect x="8" y="10" width="1" height="1" fill="rgba(7, 4, 3, 255)" />
<rect x="9" y="10" width="1" height="1" fill="rgba(7, 4, 3, 255)" />
</svg>);
export default MinecraftLeatherHelmetOverlay;